/*global AppBuildConfig*/

export default angular.module('installer.config', []).
  constant('installerConfig', {
    backend: {
      url: AppBuildConfig.backendUrl,
      bundleRootURL: AppBuildConfig.bundleRootURL
    },
    build: {
      version: AppBuildConfig.version,
      number: AppBuildConfig.number
    }
  });



// WEBPACK FOOTER //
// ./src/blocks/app/app__config.js